import React from "react";
import { useHistory } from "react-router-dom";
import "./SiteTableRow.css";
import SSLTableElement from "../SSLTableElement/SSLTableElement";
import RerunCheckup from "../Common/RerunCheckup/RerunCheckup";
import TrueFalseTableElement from "../Common/TrueFalseTableElement/TrueFalseTableElement";
import { extractFloorlytics } from "../../utils";

function SiteTableRow(props) {
  let history = useHistory();

  const url =
    props.ssl_expiration === "Non-SSL Site"
      ? `http://${props.url}`
      : `https://${props.url}`;

  const runDate = new Date(props.date);
  const handleClick = () => {
    if (typeof window.analytics !== "undefined")
      window.analytics.track("Website row clicked", {
        url: `${props.url}`
      });

    history.push("/" + props.url);
  };

  return (
    <tr className="site-table--props" onClick={handleClick}>
      <td>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => e.stopPropagation()}
        >
          {props.url}
        </a>
      </td>
      <td>{props.status}</td>
      <SSLTableElement expiration={props.ssl_expiration} />
      <td className={props.site_speed <= 60 ? "alert" : ""}>
        {props.site_speed}
      </td>
      <td className={props.site_speed <= 60 ? "alert" : ""}>
        {props.mobile_site_speed}
      </td>
      <td className="flooryltics-column">
        <TrueFalseTableElement {...extractFloorlytics(props)} />
      </td>
      <td>{props.broken_links || 0}</td>
      <td>
        {`${runDate.toLocaleDateString()}  ${runDate.toLocaleTimeString()}`}
      </td>
      <td className="column-line column-line__re-run">
        <RerunCheckup url={props.url} />
      </td>
    </tr>
  );
}

export default SiteTableRow;
